import {TableState, tableStateToParams} from "../components/EnhancedTable/EnhancedTable";
import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {getCurrentUser, getUsers, updateUser} from "../utils/Api";

/**
 * Gets the currently logged-in user.
 */
export const useCurrentUser = () => {
    return useQuery({
        queryKey: ["currentUser"],
        refetchOnWindowFocus: false,
        retry: false,
        queryFn: getCurrentUser
    });
}

/**
 * Get Users for the user's table.
 */
export const useUsersTableData = (tableState: TableState) => {
    const queryParams = tableStateToParams(tableState);
    return useQuery(["users", queryParams], async () => {
        return await getUsers(queryParams);
    });
}

/**
 * Update user mutation.
 */
export const useUpdateUser = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (
            variables: { id: number, payload: object }
        ) => {
            return updateUser(variables.id, variables.payload)
        },
        onSuccess: (resData, variables) => {
            queryClient.setQueriesData(["users"], (oldData: any) => {
                const newResults = oldData['results'].map(user => {
                    if (user.id === resData.id) {
                        return resData;
                    }
                    return user;
                });

                return {
                    ...(oldData as object),
                    results: newResults
                }
            });

            queryClient.setQueryData(["currentUser"], (oldData: any) => {
                if (oldData.id === resData.id) {
                    return resData;
                }
                return oldData
            });
        },
    });
}